import { Component, OnInit, ViewEncapsulation } from '@angular/core';

import { NetworkService } from "../../core/services/network.service";
import { CollectionService } from "../../core/services/collection.service";

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.scss'],
    encapsulation: ViewEncapsulation.None
})

export class HomeComponent implements OnInit {
    popularArray: any = [];
    recommendedArray: any = [];
    productsAreAvailable = false;

    constructor(private networkService: NetworkService, private collectionService: CollectionService) {}

    ngOnInit(): void {
        this.networkService.fetchPopular()
            .then(resArray => {
                this.popularArray = resArray;
            });
        this.networkService.fetchRecommended()
            .then(resArray => {
                this.recommendedArray = resArray
            });
        this.productsAreAvailable = true;
    }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/(IGH Projects)/jobs/EVFS PROD_FRONTEND granima.de/workspace/frontend/src/app/pages/home/home.component.ts